// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-2f62a","icon_empty":"icon_empty-1YjUm"};